import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../../store/store.interface";
import { DiscountDetails, UpdatePromoCodePrams } from "../../../promo-code/interfaces/promo-code.interface";
import { isGuestCheckoutPage } from "../../../../common/environment";
import { getPromoCodeDiscountMagentoApiCall, getPromoCodeDiscountMagentoApiCallGuestCheckout } from "../../../promo-code/api/promo-code.apis";
import { getCartIdFromURL } from "../../../../common/constants/guest-checkout-api";
import { getCustomerToken } from "../../../customer/customer";
import { updateSkipFreightCalculation, recalculateTax } from "../../../checkout/shop-checkout";
import { getShopCart } from "./get-shop-cart.thunk";
import { ActionStatus } from "../../../../common/constants/action-status";
import { NATIONAL_STORE } from "../../../../common/utils/cart-util";

export const updatePromoCode = createAsyncThunk('shopCart/updatePromoCode', async ({ promoCode, storeCode = NATIONAL_STORE }: UpdatePromoCodePrams, thunkAPI) => {
    const state = thunkAPI.getState() as StoreState;

    const oldPromoCode = state.promoCodeDiscountState.updatePromoCode.data?.coupon;

    if (!promoCode && oldPromoCode) {
      promoCode = oldPromoCode;
    } else if (!promoCode) {
      promoCode = '';
    }

    let discountDetails: DiscountDetails | undefined = undefined;
    try {
      if (isGuestCheckoutPage()) {
        discountDetails = await getPromoCodeDiscountMagentoApiCallGuestCheckout(promoCode, getCartIdFromURL());
      } else {
        const customerToken = getCustomerToken(state);
        discountDetails = await getPromoCodeDiscountMagentoApiCall(promoCode, customerToken);
      }
      thunkAPI.dispatch(updateSkipFreightCalculation(false));

      await thunkAPI.dispatch(getShopCart({ forceUpdate: true, promoCode: promoCode, store: storeCode })).unwrap();
      await recalculateTax(state, promoCode, thunkAPI);

      return discountDetails;
    } catch (error) {
      // if promocode is invalid updating estimated price without the discount.
      await thunkAPI.dispatch(getShopCart({ forceUpdate: true, promoCode: promoCode, store: storeCode })).unwrap();
      await recalculateTax(state, promoCode, thunkAPI);

      return thunkAPI.rejectWithValue({
        promoCode: '',
        message: error
      });

    }
  }, {
    condition: (({ promoCode, forceUpdate }: UpdatePromoCodePrams, { getState }) => {
      const state = getState() as StoreState;
      return (state.promoCodeDiscountState.updatePromoCode.status !== ActionStatus.loading && promoCode !== state.promoCodeDiscountState.updatePromoCode.data?.coupon) || forceUpdate;
    })
  });
